import { useState } from 'react';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';

function AuthGate({ initialMode }) {
  const [mode, setMode] = useState(initialMode || 'login');

  return mode === 'login'
    ? <LoginPage onSwitchToSignup={() => setMode('signup')} />
    : <SignupPage onSwitchToLogin={() => setMode('login')} />;
}

export default AuthGate;
